import script from "./PolicyEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyEditorView.vue?vue&type=script&setup=true&lang=js"

import "./PolicyEditorView.vue?vue&type=style&index=0&id=208087a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208087a9"]])

export default __exports__